var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dropdown",
        {
          staticStyle: {
            "margin-left": "5px",
            "margin-right": "15px",
            position: "relative"
          },
          attrs: { trigger: "click" },
          on: { command: _vm.openIm, "visible-change": _vm.getImShow }
        },
        [
          _c(
            "el-badge",
            {
              staticClass: "right-menu-item-im",
              attrs: { hidden: !_vm.total, value: _vm.total, max: 99 }
            },
            [
              _c("svg-icon", {
                staticStyle: { "font-size": "20px" },
                attrs: { "icon-class": "information" }
              })
            ],
            1
          ),
          _c(
            "el-dropdown-menu",
            {
              ref: "messageDrop",
              staticClass: "communicate",
              attrs: { slot: "dropdown" },
              slot: "dropdown"
            },
            [
              _c(
                "el-dropdown-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.imShow,
                      expression: "imShow"
                    }
                  ]
                },
                [_c("span", [_vm._v("loading...")])]
              ),
              _c(
                "el-dropdown-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.imShow && _vm.innerGroup && _vm.isDropdown,
                      expression: "!imShow && innerGroup && isDropdown"
                    }
                  ],
                  attrs: { command: _vm.$t("Message.ChatInside") }
                },
                [
                  _c(
                    "el-badge",
                    {
                      attrs: {
                        hidden: !_vm.innerGroupUnreadNum,
                        value: _vm.innerGroupUnreadNum,
                        max: 99
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("Message.ChatInside")))])]
                  )
                ],
                1
              ),
              _c(
                "el-dropdown-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.imShow && _vm.outGroup && _vm.isDropdown,
                      expression: "!imShow && outGroup && isDropdown"
                    }
                  ],
                  attrs: { command: _vm.$t("Message.ChatByClient") }
                },
                [
                  _c(
                    "el-badge",
                    {
                      attrs: {
                        hidden: !_vm.outGroupUnreadNum,
                        value: _vm.outGroupUnreadNum,
                        max: 99
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Message.ChatByClient")))
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }